import React from "react";
import { Text } from "rebass/styled-components";

import { useRiotLink } from "../../../Hooks/useRiotLink";
import {
  DialogCard,
  DismissButton,
  PrimaryButton,
} from "../RiotRelink/styledComponents";

interface IClipRefusedModalProps {
  message: string;
  relink?: boolean;
  onClose: () => void;
}

// Shown inside a usePortal Modal when momentCreateClip refuses synchronously
// (replay gate, missing match…), so the reason is readable instead of a
// one-line footnote.
export const ClipRefusedModal = ({
  message,
  relink = false,
  onClose,
}: IClipRefusedModalProps) => {
  const { link } = useRiotLink();

  const reconnect = () => {
    onClose();
    link("CLIP_SURFACE", { reconnect: true });
  };

  return (
    <DialogCard role="alertdialog" aria-labelledby="clip-refused-title">
      <Text
        id="clip-refused-title"
        variant="text.headingMedium"
        fontWeight={700}
        textAlign="center"
      >
        {relink ? "Reconnect your Riot account" : "Couldn't create this clip"}
      </Text>
      <Text variant="text.paragraphMedium" color="chalk" textAlign="center">
        {message}
      </Text>
      {relink && <PrimaryButton onClick={reconnect}>Reconnect</PrimaryButton>}
      <DismissButton onClick={onClose}>
        {relink ? "Not now" : "Got it"}
      </DismissButton>
    </DialogCard>
  );
};
